import { motion } from "framer-motion";
import { CreditCard, Smartphone, Wallet } from "lucide-react";
import { useLang } from "../../site-context";

const EASE = [0.22, 1, 0.36, 1];

export default function Payments() {
  const { t } = useLang();
  const methods = [
    { icon: CreditCard, title: t.pay_card, desc: t.pay_card_desc, testid: "payment-card" },
    { icon: Smartphone, title: t.pay_apple, desc: t.pay_apple_desc, testid: "payment-applepay" },
    { icon: Wallet, title: t.pay_mbway, desc: t.pay_mbway_desc, testid: "payment-mbway" },
  ];

  return (
    <section className="relative border-y border-[#e3a008]/10 bg-[#0d1830] py-20 lg:py-24" data-testid="payments-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="mb-12 text-center"
        >
          <p className="ff-mono mb-4 text-[11px] uppercase tracking-[0.35em] text-[#e3a008] sm:text-xs">
            {t.payments_eyebrow}
          </p>
          <h2 className="ff-display text-3xl font-semibold tracking-tight text-white sm:text-4xl">
            {t.payments_title}
          </h2>
          <p className="mt-3 text-base font-light text-slate-400">{t.payments_sub}</p>
        </motion.div>

        <div className="grid gap-5 sm:grid-cols-3" data-testid="payment-method-strip">
          {methods.map((m, i) => (
            <motion.div
              key={m.title}
              data-testid={m.testid}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: EASE }}
              whileHover={{ y: -6 }}
              className="flex items-center gap-5 rounded-2xl border border-[#e3a008]/15 bg-[#12233f]/60 p-6 transition-colors duration-500 hover:border-[#e3a008]/45"
            >
              <div className="rounded-xl border border-[#e3a008]/25 bg-[#e3a008]/10 p-3.5">
                <m.icon className="h-6 w-6 text-[#e3a008]" strokeWidth={1.75} />
              </div>
              <div>
                <h3 className="ff-display text-lg font-semibold text-white">{m.title}</h3>
                <p className="mt-0.5 text-sm font-light text-slate-400">{m.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
